import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState } from './patchApplicationHandlers';

export const acceptOfferHandler = [
    http.put('*/api/cl_loanapp_proxy_service/v1/:countryCode/offers/:arn', async () => {
        // Simulate the next step in the flow
        const session = MockServiceWorker.getMockedSession();
        session.state = getNextState('ACCEPT_OFFER_MAIN_APPLICANT');
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json([]);
    }),
];
